import PropTypes from 'prop-types'
import { memo, useEffect, useMemo, useRef } from 'react'
import classNames from 'lib/util/classNames'
import { useSlideshowContext } from '../Slideshow'
import styles from './Slide.module.scss'

/**
 * The `Slide`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Slide (props) {
  const { children, className, index } = props
  const ref = useRef()
  const { slideTargetIndex } = useSlideshowContext()
  const classNameOutput = useMemo(
    () => classNames([className, styles.container]),
    [className]
  )
  const currentTargetIndex = useRef(0)

  /**
   * Effect: When the `slideTargetIndex` changes
   */
  useEffect(() => {
    if (slideTargetIndex === currentTargetIndex.current) {
      return
    }

    if (slideTargetIndex === index) {
      ref.current.parentNode.scrollTo({
        left: ref.current.offsetLeft,
        behavior: 'smooth'
      })
    }

    currentTargetIndex.current = slideTargetIndex
  }, [slideTargetIndex, index])

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
}

/** @type {object} */
Slide.propTypes = {
  index: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node
}

/** @type {object} */
Slide.defaultProps = {
  index: 0,
  className: '',
  children: null
}

// Memoize
export default memo(Slide)
